import ExplorerIcon from "../../../assets/svg/explorer.svg";
import mainLogo from "../../../assets/png/tuataraLogo.png";
import mapMarkerIcon from "../../../assets/svg/mapMarkerIcon.svg";
import mapMarkerIconSm from "../../../assets/svg/mapMarkerIconSm.svg";
import searchIcon from "../../../assets/svg/searchIcon.svg";
import ExternalLink from "../../../assets/svg/External_Link.svg";
import "../index.css";
import ListIcon from "@mui/icons-material/List";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Box, Drawer, Menu } from "@mui/material";
import { Close } from "@mui/icons-material";
import UtilityVehicles from "./SubMenu/utilityvehicles";
import Industries from "./SubMenu/industries";
import ServicesSupport from "./SubMenu/servicesSupport";
import About from "./SubMenu/about";
import ContactUs from "./SubMenu/contactus";
import CustomAccordion from "./customAccordion/CustomAccordion";
import TUSC01 from "../../../assets/png/TUSC01.png";
import WarningModal from "../../../common/WarningModel";
import { useMsal } from "@azure/msal-react";
import { ApplicationId, vizybilityConfig } from "../../../api/url";
import { loginRequest } from "../../../config/msalConfig";
import { jwtDecode } from "jwt-decode";
import { postGetVizyBilityToken } from "../../../services/getVizyBilityToken";
import { RouterPaths } from "../../../router/router";
import Attachements from "./SubMenu/attachements";
import Flag_USA from "../../../assets/images/Flag_USA.jpg";
import ContactFormModal from "./contact/ContactFormModal";
import RegionSwitcher from "../RegionSwitcher/RegionSwitcher";
// import { useAuth } from "../../../auth/AuthContext";
// import { useAuthModal } from "../../../context/authModalContext";

const HomeHeader = () => {
  const { instance, accounts } = useMsal();
  // New vizy-identity auth hooks (replace MSAL popup for the DEALER PORTAL button).
  // const { isAuthenticated } = useAuth();
  // const { openModal } = useAuthModal();
  const menuRef = useRef(null);
  const subMenuRef = useRef(null);
  const [showSubManu, setShowSubManu] = useState(false);
  const [subManuItem, setSubManuItem] = useState("MODEL");

  const [showAttSubManu, setShowAttSubManu] = useState(false);
  const [subAttManuItem, setSubAttManuItem] = useState("ATTACHMENTS");

  const [openWarning, setOpenWarning] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const [subMenuWidth, setSubMenuWidth] = useState({
    offsetLeft: 0,
    offsetWidth: 0,
  });

  //INDUSTRIES
  const [iShowSubManu, setIShowSubManu] = useState(false);
  const [iSubManuItem, setISubManuItem] = useState("DEFENSE");

  //INDUSTRIES
  const [sShowSubManu, setSShowSubManu] = useState(false);
  const [sSubManuItem, setSSubManuItem] = useState("GASOLINE");

  //ABOUT
  const [aShowSubManu, setAShowSubManu] = useState(false);
  const [aSubManuItem, setASubManuItem] = useState("ABOUT_TUATARA");

  //CONTACT US
  const [cShowSubManu, setCShowSubManu] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleOpenContact = () => setShowContactForm(true);
    window.addEventListener("openContactModal", handleOpenContact);
    return () =>
      window.removeEventListener("openContactModal", handleOpenContact);
  }, []);

  useEffect(() => {
    const element = menuRef.current;

    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        setHeight(element.offsetHeight);
      });

      resizeObserver.observe(element);

      return () => {
        resizeObserver.disconnect(); // Clean up the observer
      };
    }
  }, []);

  useEffect(() => {
    const element = subMenuRef.current;

    if (element) {
      const resizeObserver = new ResizeObserver(() => {
        setSubMenuWidth(element);
      });

      resizeObserver.observe(element);

      return () => {
        resizeObserver.disconnect(); // Clean up the observer
      };
    }
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeAllManu = () => {
    setSubManuItem("MODEL");
    setSubAttManuItem("ATTACHMENTS");
    setISubManuItem("DEFENSE");
    setSSubManuItem("GASOLINE");
    setASubManuItem("ABOUT_TUATARA");
    setIShowSubManu(false);
    setShowSubManu(false);
    setSShowSubManu(false);
    setAShowSubManu(false);
    setCShowSubManu(false);
    setIsOpen(false);
    setShowAttSubManu(false);
  };

  const openAttManu = () => {
    setShowAttSubManu(true);
    setShowSubManu(false);
    setIShowSubManu(false);
    setSShowSubManu(false);
    setAShowSubManu(false);
  };
  // ======================
  const openManu = () => {
    setShowSubManu(true);
    setShowAttSubManu(false);
    setIShowSubManu(false);
    setSShowSubManu(false);
    setAShowSubManu(false);
  };
  // =======================
  const openIndustries = () => {
    setShowSubManu(false);
    setShowAttSubManu(false);
    setSShowSubManu(false);
    setAShowSubManu(false);
    setIShowSubManu(true);
  };

  // =======================
  const openServices = () => {
    setShowSubManu(false);
    setIShowSubManu(false);
    setShowAttSubManu(false);
    setAShowSubManu(false);
    setSShowSubManu(true);
  };

  // =======================
  const openAbout = () => {
    setShowSubManu(false);
    setShowAttSubManu(false);
    setIShowSubManu(false);
    setSShowSubManu(false);
    setAShowSubManu(true);
    setCShowSubManu(false);
  };

  // =======================
  const openContactUs = () => {
    setShowSubManu(false);
    setShowAttSubManu(false);
    setIShowSubManu(false);
    setSShowSubManu(false);
    setAShowSubManu(false);
    setCShowSubManu(true);
  };

  const handleOpenWarning = () => {
    setOpenWarning(true);
    localStorage.setItem("OpenWarning", true);
  };

  // New DEALER PORTAL click handler — opens the vizy-identity login modal
  // when not authenticated, otherwise navigates straight into the portal.
  // const handleDealerPortalClick = () => {
  //   if (isAuthenticated) {
  //     navigate("/dealers-portal");
  //   } else {
  //     openModal("login");
  //   }
  // };

  /* LEGACY: Azure B2C popup login + STS exchange — kept for rollback.
  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const idToken = await instance.loginPopup(loginRequest);
      handleRedirectCallback(idToken.accessToken);
    } catch (error) {
      console.error("Login error:", error);
      setIsLoading(false);
    }
  };

  const handleRedirectCallback = async (response) => {
    try {
      const decodedToken = jwtDecode(response);
      if (decodedToken?.extension_UserStatus) {
        // Stop loading after processing response
        if (
          decodedToken.extension_UserStatus === undefined ||
          decodedToken.extension_UserStatus === "Pending"
        ) {
          await instance.logoutPopup({
            postLogoutRedirectUri: window.location.origin,
          });
          setIsLoading(false);
          handleOpenWarning();
          localStorage.removeItem("vizy-bility-token");
          localStorage.removeItem("client_info");
        } else if (decodedToken.extension_UserStatus === "Approved") {
          let payload = new URLSearchParams({
            grant_type: vizybilityConfig.grant_type,
            username: decodedToken.extension_GenericWebUsername,
            password: decodedToken.extension_GenericWebUserPassword,
            client_id: vizybilityConfig.STS_CLIENT_ID,
            client_secret: vizybilityConfig.STS_CLIENT_SECRET,
            scope: vizybilityConfig.STS_SCOPE,
            ApplicationId: getApplicationId(),
          });
          setIsLoading(true);
          postGetVizyBilityToken({
            url: vizybilityConfig.STS_SIGNIN_URL,
            payload,
          })
            .then((res) => {
              if (res?.data?.access_token) {
                localStorage.setItem(
                  "vizy-bility-token",
                  res.data.access_token,
                );
                localStorage.setItem(
                  "client_info",
                  JSON.stringify(decodedToken),
                );
                window.scrollTo(0, 0);
                setIsLoading(false);
                navigate("/dealers-portal");
              }
            })
            .catch(async (err) => {
              setIsLoading(false);
              handleOpenWarning();
              await instance.logoutPopup({
                postLogoutRedirectUri: window.location.origin,
              });
              localStorage.removeItem("vizy-bility-token");
              localStorage.removeItem("client_info");
            });
        } else {
          await instance.logoutPopup({
            postLogoutRedirectUri: window.location.origin,
          });
          setIsLoading(false);
          handleOpenWarning();

          localStorage.removeItem("vizy-bility-token");
          localStorage.removeItem("client_info");
        }
      } else {
        handleOpenWarning();
        await instance.logoutPopup({
          postLogoutRedirectUri: window.location.origin,
        });
        localStorage.removeItem("vizy-bility-token");
        localStorage.removeItem("client_info");
      }
    } catch (error) {
      console.error("Error handling redirect callback:", error);
      setIsLoading(false); // Stop loading on error
    } finally {
    }
  };
  */

  const handleCloseWarning = () => {
    setIsLoading(false);
    setOpenWarning(false);
    localStorage.removeItem("OpenWarning");
  };

  return (
    <>
      <header
        className={`sticky top-0 z-[100] header-bg transition-colors duration-300 relative`}
        ref={menuRef}
        onMouseLeave={() => closeAllManu()}
      >
        {isLoading ? (
          <div className="absolute w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center">
            <span class="loader"></span>
          </div>
        ) : null}
        <div className="bg-[#292929]" onMouseEnter={() => closeAllManu()}>
          <div className=" max-w-[1440px] mx-auto flex items-center justify-between md:px-[3rem] px-[1rem] min-h-[70px]">
            <div className="flex items-center">
              <RegionSwitcher />
            </div>

            {/* <div
              className="flex items-end py-[20px] cursor-pointer "
              onClick={handleDealerPortalClick}
            >
              <span className="text-[16px] font-normal font-[Roboto] text-white">
                DEALER PORTAL
              </span>
              <img src={ExplorerIcon} alt="" className="w-[30px] ml-[14px]" />
            </div> */}
          </div>
        </div>
        <div
          className="bg-[#F2F2F2]"
          style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
        >
          <div className="custom-container sm:py-[20px] py-[20px] flex justify-between  md:px-[3rem] px-[1rem]">
            {/* Logo */}
            <div>
              <img
                src={mainLogo}
                className="w-auto h-[60px] cursor-pointer sm:h-[80px]"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/us");
                }}
              />
            </div>

            {/* Menu */}
            <div className="flex items-center" ref={subMenuRef}>
              <div
                className="relative mr-[35px] cursor-pointer max-[1346px]:hidden font-[Roboto] text-[20px] whitespace-nowrap"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(RouterPaths.UtilityVehicles);
                }}
                onMouseEnter={() => openManu()}
              >
                <span className="font-bold invisible whitespace-nowrap">UTILITY VEHICLES</span>
                <span
                  className={`absolute inset-0 flex items-center ${
                    window.location.pathname === RouterPaths.UtilityVehicles ||
                    window.location.pathname === RouterPaths.TU1500E2 ||
                    window.location.pathname === RouterPaths.TU1500E3 ||
                    window.location.pathname === RouterPaths.TU1500E4 ||
                    window.location.pathname === RouterPaths.TUDC2500E1 ||
                    window.location.pathname === RouterPaths.TUSC2500E1 ||
                    window.location.pathname === RouterPaths.EFI ||
                    showSubManu
                      ? "text-[#5B792E]"
                      : "text-[#292929]"
                  } font-normal font-[Roboto] text-[20px]  mr-[35px] cursor-pointer  max-[1346px]:hidden`}
                >
                  UTILITY VEHICLES
                </span>
              </div>
              <div
                className="relative mr-[35px] cursor-pointer max-[1346px]:hidden font-[Roboto] text-[20px]"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(RouterPaths.UtilityVehicles);
                }}
                onMouseEnter={() => openAttManu()}
              >
                <span className="font-bold invisible">ATTACHMENTS</span>
                <span
                  className={`absolute inset-0 flex items-center ${
                    window.location.pathname === RouterPaths.Attachments ||
                    showAttSubManu
                      ? "text-[#5B792E]"
                      : "text-[#292929]"
                  } font-normal font-[Roboto] text-[20px]  mr-[35px] cursor-pointer  max-[1346px]:hidden`}
                >
                  ATTACHMENTS
                </span>
              </div>
              {/* <div
                className={`${
                  window.location.pathname === RouterPaths.Defend || iShowSubManu
                    ? "font-bold text-[#5B792E]"
                    : "font-normal text-[#292929]"
                }  font-[Roboto] text-[20px]  mr-[35px] cursor-pointer  max-[1346px]:hidden`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(RouterPaths.Defend);
                }}
                onMouseEnter={() => openIndustries()}
              >
                INDUSTRIES
              </div> */}
              {/* <div
                className={`${window.location.pathname === RouterPaths.ServicesAndSupport || sShowSubManu
                  ? "font-bold text-[#5B792E]"
                  : "font-normal text-[#292929]"
                  }  font-[Roboto] text-[20px]  mr-[35px] cursor-pointer  max-[1346px]:hidden`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(RouterPaths.ServicesAndSupport);
                }}
                onMouseEnter={() => openServices()}
              >
                WARRANTY
              </div> */}
              <div
                className={`${
                  window.location.pathname === RouterPaths.About || aShowSubManu
                    ? "text-[#5B792E]"
                    : "text-[#292929]"
                } font-normal font-[Roboto] text-[20px]  mr-[35px] cursor-pointer  max-[1346px]:hidden`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(RouterPaths.About);
                }}
                onMouseEnter={() => openAbout()}
              >
                ABOUT
              </div>
              <div
                className={`${
                  window.location.pathname === RouterPaths.Blog
                    ? "text-[#5B792E]"
                    : "text-[#292929]"
                } hover:text-[#5B792E] font-normal font-[Roboto] text-[20px]  mr-[35px] cursor-pointer  max-[1346px]:hidden`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(RouterPaths.Blog);
                }}
                onMouseEnter={() => closeAllManu()}
              >
                BLOG
              </div>
              <div
                className={`${
                  window.location.pathname === RouterPaths.BecomeADealer
                    ? "text-[#5B792E]"
                    : "text-[#292929]"
                } font-normal font-[Roboto] text-[20px]  mr-[35px] cursor-pointer  max-[1346px]:hidden whitespace-nowrap`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(RouterPaths.BecomeADealer);
                }}
                onMouseEnter={() => closeAllManu()}
              >
                BECOME A DEALER
              </div>
              <div
                className={`${
                  cShowSubManu ? "text-[#5B792E]" : "text-[#292929]"
                } font-normal font-[Roboto] text-[20px]  mr-[35px] cursor-pointer  max-[1346px]:hidden whitespace-nowrap`}
                onMouseEnter={() => openContactUs()}
              >
                CONTACT US
              </div>
              {/* <div
                className="text-[#292929] font-[Roboto] text-[20px] font-normal flex items-center  mr-[35px] cursor-pointer  max-[1346px]:hidden"
                onMouseEnter={() => closeAllManu()}
              >
                <img src={mapMarkerIcon} alt="" className="w-[43px] h-[56px]" />
                FIND A DEALER
              </div> */}
              <div onMouseEnter={() => closeAllManu()}>
                <img
                  src={searchIcon}
                  alt=""
                  className="sm:h-[35px] sm:w-[25px] h-[26px] w-[26px] cursor-pointer"
                />
              </div>
              <div
                className="hidden max-[1346px]:flex ml-[30px]"
                onClick={toggleMenu}
              >
                <ListIcon className="!text-[#89c56e] !text-[26px] sm:!text-[35px] cursor-pointer" />
              </div>
            </div>
          </div>
        </div>

        {/* Sub Menu */}
        {showSubManu ? (
          <UtilityVehicles
            subMenuWidth={subMenuWidth}
            subManuItem={subManuItem}
            openManu={openManu}
            closeAllManu={closeAllManu}
            setSubManuItem={setSubManuItem}
            height={height}
          />
        ) : null}

        {/* Sub Menu */}

        {showAttSubManu ? (
          <Attachements
            subMenuWidth={subMenuWidth}
            subManuItem={subAttManuItem}
            openManu={openAttManu}
            closeAllManu={closeAllManu}
            setSubManuItem={setSubAttManuItem}
            height={height}
          />
        ) : null}

        {/* Sub Menu INDUSTRIES*/}
        {iShowSubManu ? (
          <Industries
            subMenuWidth={subMenuWidth}
            openIndustries={openIndustries}
            iSubManuItem={iSubManuItem}
            closeAllManu={closeAllManu}
            setISubManuItem={setISubManuItem}
            height={height}
          />
        ) : null}

        {/* Sub Menu SERVICES & SUPPORT*/}
        {sShowSubManu ? (
          <ServicesSupport
            openServices={openServices}
            sSubManuItem={sSubManuItem}
            setSSubManuItem={setSSubManuItem}
            subMenuWidth={subMenuWidth}
            closeAllManu={closeAllManu}
            height={height}
          />
        ) : null}

        {/* Sub Menu ABOUT*/}
        {aShowSubManu ? (
          <About
            aSubManuItem={aSubManuItem}
            setASubManuItem={setASubManuItem}
            openAbout={openAbout}
            subMenuWidth={subMenuWidth}
            closeAllManu={closeAllManu}
            height={height}
          />
        ) : null}

        {/* Sub Menu CONTACT US*/}
        {cShowSubManu ? (
          <ContactUs
            openContactUs={openContactUs}
            subMenuWidth={subMenuWidth}
            closeAllManu={closeAllManu}
            height={height}
            setShowContactForm={setShowContactForm}
          />
        ) : null}

        <div>
          <Drawer
            open={isOpen}
            anchor="right"
            onClose={() => {
              toggleMenu();
            }}
          >
            <Box className="flex-col py-5 w-[320px] p-[20px]">
              <div key={1} className="my-7">
                <div className="mb-[15px] text-end">
                  <Close className=" cursor-pointer" onClick={toggleMenu} />
                </div>
                <div className="flex items-start  flex-col">
                  <CustomAccordion
                    value={
                      <div
                        className={`
                    ${
                      window.location.pathname ===
                        RouterPaths.UtilityVehicles ||
                      window.location.pathname === RouterPaths.TU1500E2 ||
                      window.location.pathname === RouterPaths.TU1500E3 ||
                      window.location.pathname === RouterPaths.TU1500E4 ||
                      window.location.pathname === RouterPaths.TUDC2500E1 ||
                      window.location.pathname === RouterPaths.TUSC2500E1 ||
                      window.location.pathname === RouterPaths.EFI
                        ? "text-[#5B792E]"
                        : "text-[#292929]"
                    } font-[Roboto] font-bold text-[18px] cursor-pointer`}
                        onClick={() => {
                          toggleMenu();
                          window.scrollTo(0, 0);
                          navigate(RouterPaths.UtilityVehicles);
                        }}
                      >
                        UTILITY VEHICLES
                      </div>
                    }
                    toggleMenu={toggleMenu}
                    children={
                      <>
                        <div className="flex-grow col-span-2">
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              closeAllManu();
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.EFI);
                            }}
                          >
                            1000EFI-2 Gasoline
                          </div>
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.TU1500E2);
                              closeAllManu();
                            }}
                          >
                            1500E-2 Electric
                          </div>
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.TU1500E3);
                              closeAllManu();
                            }}
                          >
                            1500E-3 Electric
                          </div>
                          {/* <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.TU1500E4);
                              closeAllManu();
                            }}
                          >
                            1500E-4 Electric
                          </div> */}
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.TUSC2500E1);
                              closeAllManu();
                            }}
                          >
                            SC2500E-01 Dual Motor
                          </div>
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.TUDC2500E1);
                              closeAllManu();
                            }}
                          >
                            DC2500E-01 Dual Motor
                          </div>
                        </div>
                        <div>
                          <div className="flex-grow col-span-2">
                            <img src={TUSC01} alt="" className="w-[100%]" />
                          </div>
                          <div>
                            <button
                              className="w-full bg-[#7ABF5B] font-[Roboto] text-[18px] text-[#fff] px-[30px] py-[10px] font-bold my-[10px]"
                              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                            >
                              GET STARTED
                            </button>
                          </div>
                        </div>
                      </>
                    }
                  />

                  <CustomAccordion
                    value={
                      <div
                        className={`
                    ${
                      window.location.pathname === RouterPaths.Attachments
                        ? "text-[#5B792E]"
                        : "text-[#292929]"
                    } font-[Roboto] font-bold text-[18px] cursor-pointer`}
                        onClick={() => {
                          toggleMenu();
                          window.scrollTo(0, 0);
                          navigate(RouterPaths.UtilityVehicles);
                        }}
                      >
                        ATTACHMENTS
                      </div>
                    }
                    toggleMenu={toggleMenu}
                    children={
                      <>
                        <div className="flex-grow col-span-2">
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.Attachments);
                              closeAllManu();
                            }}
                          >
                            Air Conditioner/Heater
                          </div>
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.Attachments);
                              closeAllManu();
                            }}
                          >
                            Doors
                          </div>
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.Attachments);
                              closeAllManu();
                            }}
                          >
                            Windshield
                          </div>
                          {/* <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.Attachments);
                              closeAllManu();
                            }}
                          >
                            Raptor Bed Liner
                          </div> */}
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.Attachments);
                              closeAllManu();
                            }}
                          >
                            Rear Deck
                          </div>
                          <div
                            className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(RouterPaths.Attachments);
                              closeAllManu();
                            }}
                          >
                            Orchard Kit
                          </div>
                        </div>
                        <div>
                          <div className="flex-grow col-span-2">
                            <img src={TUSC01} alt="" className="w-[100%]" />
                          </div>
                          <div>
                            <button
                              className="w-full bg-[#7ABF5B] font-[Roboto] text-[18px] text-[#fff] px-[30px] py-[10px] font-bold my-[10px]"
                              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                            >
                              GET STARTED
                            </button>
                          </div>
                        </div>
                      </>
                    }
                  />
                  {/* <CustomAccordion
                    value={
                      <div
                        className={`
                    ${window.location.pathname === RouterPaths.Defend ? "text-[#5B792E]" : "text-[#292929]"}
                     font-[Roboto] text-[18px] font-bold cursor-pointer`}
                        onClick={() => {
                          toggleMenu();
                          window.scrollTo(0, 0);
                          navigate(RouterPaths.Defend);
                        }}
                      >
                        INDUSTRIES
                      </div>
                    }
                    toggleMenu={toggleMenu}
                    children={
                      <>
                        <CustomAccordion
                          value={"GOVERNMENT"}
                          toggleMenu={toggleMenu}
                          children={
                            <div className="flex-grow col-span-2">
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Federal
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                State
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Municipal
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Emergency Response
                              </div>
                              <div className="pt-[20px]">
                                <div>
                                  <div className="font-bold text-[18px] font-[Roboto] text-[#000]">
                                    Contact A Government Representative Today
                                  </div>
                                  <div>
                                    <div className="font-normal text-[18px] font-[Roboto] text-[#000] mt-[20px]">
                                      Serve and respond with the best equipment through a Government Representative
                                      today.
                                    </div>
                                  </div>
                                </div>
                                <button
                                  className="w-full border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[18px] px-[30px] py-[10px] font-bold my-[10px]"
                                  style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                                >
                                  CONTACT TODAY
                                </button>
                              </div>
                            </div>
                          }
                        />
                        <CustomAccordion
                          value={"DEFENSE"}
                          toggleMenu={toggleMenu}
                          children={
                            <div className="flex-grow col-span-2">
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate(RouterPaths.Attachments);
                                  closeAllManu();
                                }}
                              >
                                Air Conditioner/Heater
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate(RouterPaths.Attachments);
                                  closeAllManu();
                                }}
                              >
                                Doors
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate(RouterPaths.Attachments);
                                  closeAllManu();
                                }}
                              >
                                Windshield
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate(RouterPaths.Attachments);
                                  closeAllManu();
                                }}
                              >
                                Raptor Bed Liner
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate(RouterPaths.Attachments);
                                  closeAllManu();
                                }}
                              >
                                Rear Deck
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate(RouterPaths.Attachments);
                                  closeAllManu();
                                }}
                              >
                                Orchard Kit
                              </div>
                              <div className="pt-[20px]">
                                <div>
                                  <div className="font-bold text-[18px] font-[Roboto] text-[#000]">
                                    Contact A Defense Representative Today
                                  </div>
                                  <div>
                                    <div className="font-normal text-[18px] font-[Roboto] text-[#000] mt-[20px]">
                                      Get tactical specifcto your mission needs with a Defense Representative today.
                                    </div>
                                  </div>
                                </div>
                                <button
                                  className="w-full border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[18px] px-[30px] py-[10px] font-bold my-[10px]"
                                  style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                                >
                                  CONTACT TODAY
                                </button>
                              </div>
                            </div>
                          }
                        />

                        <CustomAccordion
                          value={"COMMERCIAL"}
                          toggleMenu={toggleMenu}
                          children={
                            <div className="flex-grow col-span-2">
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Agriculture
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Construction
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Forestry & Wildlife
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Mining, Quarries, & Refineries
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Zoos, Museums, & Recreation
                              </div>
                              <div className="pt-[20px]">
                                <div>
                                  <div className="font-bold text-[18px] font-[Roboto] text-[#000]">
                                    Contact Your Local Dealer
                                  </div>
                                  <div>
                                    <div className="font-normal text-[18px] font-[Roboto] text-[#000] mt-[20px]">
                                      Your local Tuatara dealer is a personal partner who will do whateverit takes to
                                      help your business succeed.
                                    </div>
                                  </div>
                                </div>
                                <button
                                  className="w-full border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[18px] px-[30px] py-[10px] font-bold my-[10px]"
                                  style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                                >
                                  CONTACT TODAY
                                </button>
                              </div>
                            </div>
                          }
                        />
                      </>
                    }
                  /> */}

                  {/* <CustomAccordion
                    value={
                      <div
                        className={`
                    
                    ${window.location.pathname === RouterPaths.ServicesAndSupport ? "text-[#5B792E]" : "text-[#292929]"}
                     font-[Roboto] text-[18px] font-bold cursor-pointer`}
                        onClick={() => {
                          toggleMenu();
                          window.scrollTo(0, 0);
                          navigate(RouterPaths.ServicesAndSupport);
                        }}
                      >
                        WARRANTY
                      </div>
                    }
                    toggleMenu={toggleMenu}
                    children={
                      <>
                        <CustomAccordion
                          value={"GASOLINE"}
                          toggleMenu={toggleMenu}
                          children={
                            <div className="flex-grow col-span-2">
                              <div className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px]">
                                Gasoline 1000EFI
                              </div>
                              <ul class="list-disc ml-[22px]">
                                <li className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px]">
                                  Now this is a story all about how, my life got flipped-turned upside down
                                </li>
                                <li className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px]">
                                  Standard (Included):  Vehicle Drive Train Warranty 12 months or 15,000 miles
                                </li>
                              </ul>
                            </div>
                          }
                        />

                        <CustomAccordion
                          value={"ELECTRIC"}
                          toggleMenu={toggleMenu}
                          children={
                            <div className="flex-grow col-span-2">
                              <div className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px]">
                                Electric 1500E, SC2500E, SC2300E
                              </div>
                              <ul class="list-disc ml-[22px]">
                                <li className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px]">
                                  Standard (Included): Vehicle Parts 90 days or 3,000 miles
                                </li>
                                <li className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px]">
                                  Standard (Included):  Vehicle Drive Train Warranty 12 months or 15,000 miles
                                </li>
                                <li className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px]">
                                  Battery Warranty: 5 years or 1000 cycles
                                </li>
                              </ul>
                            </div>
                          }
                        />
                      </>
                    }
                  /> */}

                  <CustomAccordion
                    value={
                      <div
                        className={`
                    ${window.location.pathname === RouterPaths.About ? "text-[#5B792E]" : "text-[#292929]"}
                    font-[Roboto] text-[18px] font-bold cursor-pointer`}
                        onClick={() => {
                          toggleMenu();
                          window.scrollTo(0, 0);
                          navigate(RouterPaths.About);
                        }}
                      >
                        ABOUT
                      </div>
                    }
                    toggleMenu={toggleMenu}
                    children={
                      <>
                        <CustomAccordion
                          value={"ABOUT TUATARA"}
                          toggleMenu={toggleMenu}
                          children={
                            <div className="flex-grow col-span-2">
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate(RouterPaths.About);
                                  closeAllManu();
                                }}
                              >
                                About Tuatara
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e] flex items-center"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                History
                              </div>
                              <div className="pt-[20px]">
                                <div>
                                  <div className="font-bold text-[18px] font-[Roboto] text-[#000]">
                                    Let’s Get To Work.{" "}
                                  </div>
                                  <div>
                                    <div className="font-normal text-[18px] font-[Roboto] text-[#000] mt-[20px]">
                                      There is work to be done worldwide, and
                                      that work is powered by Tuatara and our
                                      people. Join the team.
                                    </div>
                                  </div>
                                </div>
                                <div className=" mt-[21px] mb-[38px]">
                                  <button
                                    className="w-full border-[4px] border-[#7abf5b] text-[#fff] bg-[#7abf5b] font-[Roboto] text-[20px] text-[#fff]  py-[10px] font-bold my-[10px]"
                                    style={{
                                      boxShadow: "0px 4px 4px 0px #00000040",
                                    }}
                                  >
                                    <Link
                                      to="/us/about"
                                      onClick={() => {
                                        window.scrollTo(0, 0);
                                        closeAllManu();
                                      }}
                                    >
                                      ABOUT TUATARA
                                    </Link>
                                  </button>
                                  {/* <button
                                    className="w-full border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[18px] py-[10px] font-bold my-[10px]"
                                    style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                                  >
                                    EXPLORE CAREERS
                                  </button> */}
                                </div>
                              </div>
                            </div>
                          }
                        />

                        {/* <CustomAccordion
                          value={"INVESTORS"}
                          toggleMenu={toggleMenu}
                          children={
                            <div className="flex-grow col-span-2">
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Register to Invest
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e] flex items-center"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Become a Dealer
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Resources
                              </div>
                              <div className="pt-[0px]">
                                <div>
                                  <div className="font-bold text-[18px] font-[Roboto] text-[#000]">We Are Global</div>
                                  <div>
                                    <div className="font-normal text-[18px] font-[Roboto] text-[#000] mt-[20px]">
                                      Tuatara and Tuatara dealers across the globe are working to support our customers
                                      and their communities.
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-[20px] mb-[24px]">
                                  <div className="font-bold text-[18px] font-[Roboto] text-[#000]">History</div>
                                  <div>
                                    <div className="font-normal text-[18px] font-[Roboto] text-[#000] mt-[20px]">
                                      Explore the history of Tuatara, including the story of our two founders.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        />
                        <CustomAccordion
                          value={"COMMUNITY"}
                          toggleMenu={toggleMenu}
                          children={
                            <div className="flex-grow col-span-2">
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Philanthropy
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e] flex items-center"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Event Calendar
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Media Hub
                              </div>
                              <div
                                className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                  navigate("#");
                                  closeAllManu();
                                }}
                              >
                                Sponsorships & Affiliates
                              </div>
                              <div className="pt-[20px]">
                                <div>
                                  <div className="font-bold text-[18px] font-[Roboto] text-[#000]">
                                    Sponsorship & Affiliates
                                  </div>
                                  <div>
                                    <div className="font-normal text-[18px] font-[Roboto] text-[#000] mt-[20px]">
                                      If you believe your organization is a good fit and partnering with us can provide
                                      value and positively increase the Tuatara brand, check out our sponsorship
                                      application form.
                                    </div>
                                  </div>
                                </div>
                                <div className="w-full mt-[21px] mb-[23px]">
                                  <button
                                    className="border-[4px] border-[#7abf5b] text-[#5b792e] font-[Roboto] text-[18px] px-[30px] py-[10px] font-bold my-[10px]"
                                    style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                                  >
                                    SPONSORSHIP FORM
                                  </button>
                                </div>
                              </div>
                            </div>
                          }
                        /> */}
                      </>
                    }
                  />
                  <div className="w-full border-t-[1px] py-[12px]">
                    <div
                      className={`${window.location.pathname === RouterPaths.Blog ? "text-[#5B792E]" : "text-[#292929]"} font-[Roboto] text-[18px] font-bold flex items-center cursor-pointer`}
                      onClick={() => {
                        toggleMenu();
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.Blog);
                      }}
                    >
                      BLOG
                    </div>
                  </div>
                  <div className="w-full border-t-[1px] py-[12px]">
                    <div
                      className={`${
                        window.location.pathname === RouterPaths.BecomeADealer
                          ? "text-[#5B792E]"
                          : "text-[#292929]"
                      } font-[Roboto] text-[18px] font-bold flex items-center cursor-pointer`}
                      onClick={() => {
                        toggleMenu();
                        window.scrollTo(0, 0);
                        navigate(RouterPaths.BecomeADealer);
                      }}
                    >
                      BECOME A DEALER
                    </div>
                  </div>
                  <CustomAccordion
                    value={
                      <div className="text-[#292929] font-[Roboto] text-[18px] font-bold cursor-pointer">
                        CONTACT US
                      </div>
                    }
                    toggleMenu={toggleMenu}
                    children={
                      <div className="flex-grow col-span-2">
                        <div
                          className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                          onClick={() => {
                            window.scrollTo(0, 0);
                            navigate("#");
                            closeAllManu();
                          }}
                        >
                          Frequently Asked Questions
                        </div>
                        <div
                          className="font-normal text-[18px] font-[Roboto] text-[#000] cursor-pointer pb-[19px] hover:font-bold hover:text-[#5b792e]"
                          onClick={() => {
                            window.scrollTo(0, 0);
                            navigate("#");
                            closeAllManu();
                          }}
                        >
                          Contact Tuatara
                        </div>
                        <div className="pt-[20px]">
                          <div>
                            <div className="font-bold text-[18px] font-[Roboto] text-[#000]">
                              Let's Connect!
                            </div>
                            <div className="font-normal text-[18px] font-[Roboto] text-[#000] mt-[20px]">
                              Got questions? Find out how to connect with
                              Tuatara.
                            </div>
                          </div>
                          <div className="mt-[21px] mb-[38px]">
                            <button
                              className="w-full border-[4px] border-[#7abf5b] text-[#fff] bg-[#7abf5b] font-[Roboto] text-[18px] py-[10px] font-bold my-[10px]"
                              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
                              onClick={() => setShowContactForm(true)}
                            >
                              CONTACT TUATARA
                            </button>
                          </div>
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
            </Box>
          </Drawer>
        </div>
      </header>
      <WarningModal open={openWarning} handleClose={handleCloseWarning} />
      <ContactFormModal
        open={showContactForm}
        handleClose={() => setShowContactForm(false)}
      />
    </>
  );
};
export default HomeHeader;
